import { render, staticRenderFns } from "./PageAvaliacaoServidor.vue?vue&type=template&id=60744097&scoped=true"
import script from "./PageAvaliacaoServidor.vue?vue&type=script&lang=js"
export * from "./PageAvaliacaoServidor.vue?vue&type=script&lang=js"
import style0 from "./PageAvaliacaoServidor.vue?vue&type=style&index=0&id=60744097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60744097",
  null
  
)

export default component.exports